import type { ProjectInfo } from '@/features/projects/services/projectService';

export interface ProjectFilterDropdownAnchor {
  top: number;
  left: number;
  bottom: number;
  width: number;
  height: number;
}

export interface ProjectFilterDropdownStoreState {
  isOpen: boolean;
  anchor: ProjectFilterDropdownAnchor | null;
  triggerElement: HTMLElement | null;
  selectedProjects: string[];
  projects: ProjectInfo[];
  onProjectsChange: ((projectIds: string[]) => void) | null;
  onCreateProject?: (() => void) | undefined;
  placeholder: string;
  showColorIndicators: boolean;
  maxHeight: number;
}

type Listener = () => void;

const listeners = new Set<Listener>();

let state: ProjectFilterDropdownStoreState = {
  isOpen: false,
  anchor: null,
  triggerElement: null,
  selectedProjects: [],
  projects: [],
  onProjectsChange: null,
  onCreateProject: undefined,
  // i18n-raw-ui-literal-exempt: Canonical default is localized by ProjectFilterDropdown at its render boundary.
  placeholder: 'Select projects...',
  showColorIndicators: true,
  maxHeight: 320,
};

const emit = () => {
  listeners.forEach((listener) => listener());
};

export const subscribeProjectFilterDropdownStore = (listener: Listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const getProjectFilterDropdownStoreState = () => state;

export const openProjectFilterDropdown = (
  nextState: Omit<ProjectFilterDropdownStoreState, 'isOpen'>
) => {
  state = {
    ...nextState,
    isOpen: true,
  };
  emit();
};

export const updateProjectFilterDropdown = (
  nextState: Partial<Omit<ProjectFilterDropdownStoreState, 'isOpen'>>
) => {
  state = {
    ...state,
    ...nextState,
  };
  emit();
};

export const closeProjectFilterDropdown = () => {
  if (!state.isOpen) {
    return;
  }

  state = {
    ...state,
    isOpen: false,
  };
  emit();
};
